import { defineComponent as t, createElementBlock as n, openBlock as p, mergeProps as d, unref as o, renderSlot as f } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Drawer/drawer.js";
import { useOUIAProps as m } from "../../helpers/ouia.js";
const P = /* @__PURE__ */ t({
  name: "PfDrawerHead",
  __name: "DrawerHead",
  props: {
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(r) {
    const e = r, a = m({ id: e.ouiaId, safe: e.ouiaSafe });
    return (s, u) => (p(), n("div", d(o(a), {
      class: o(i).drawerHead
    }), [
      f(s.$slots, "default")
    ], 16));
  }
});
export {
  P as default
};
